import { secondaryTheme } from '@repo/ui/components/Buttons';
import { themeStyle } from '@repo/ui/theming';

export const alreadyVotedTheme = {
  ...secondaryTheme,
  color: themeStyle.varInkMain,
  borderColor: themeStyle.varInkMedium,
  activeColor: themeStyle.varInkMain,
  borderActiveColor: themeStyle.varInkMedium,
};

export const notVotedTheme = {
  ...secondaryTheme,
  iconActiveColor: themeStyle.varBrandMain,
};
